<template>
    <Button class="post-crossprom-dashboard" type="cpInfo" @click.native.stop="seeCpInfo">
        Preview Update
    </Button>
</template>

<script>
import Button from '../../Button'
import { objectBuilder } from '../../../../../core/utils'

export default {
    name: 'CpInfo',
    props: {
        data: Object
    },
    components: {
        Button
    },
    methods: {
        seeCpInfo() {
            
            this.$store.commit('TOGGLE_MODAL', ['sharable-content',
               objectBuilder.getUpdateInfo(this.data)
            ])

            this.$ga.event('Crossprom Info', 'Preview Update Button Click', `
                Campaign: ${this.data.campaign.title},
                Location: Dashboard Scheduled Updates
            `)
            
            this.$sendMixpanelEvent('Preview Update Button Clicked', {
                'Campaign Name': this.data.campaign.title,
                'Button Location': 'Dashboard Scheduled Updates'
            })
        }
    }
}
</script>

<style lang="scss" scoped>
div {
    padding-right: 16px;
}
</style>